import React from 'react';
import { IconActionArrowRight as IconActionArrowRightOriginal } from '@cko/icons';
import styled from 'styled-components';
import { Link } from '@cko/primitives';
const TruncatedText = styled.p `
  margin: var(--layout-sandgrain);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: inherit;
`;
const IconActionArrowRight = styled(IconActionArrowRightOriginal) `
  display: block;
  min-width: 16px;
  margin-right: var(--layout-seed);
`;
const ExternalLinkStyled = styled(Link) `
  display: inline-flex;
  align-items: center;
  color: var(--control-text-good);
  text-decoration: none;
  overflow: hidden;

  & > svg > g {
    fill: var(--control-icon-good);
  }
`;
export const ExternalLink = (props) => {
    const { children, href } = props;
    if (!children) {
        // eslint-disable-next-line no-console
        console.warn(`[ExternalLink] Element is empty`);
    }
    return (React.createElement(ExternalLinkStyled, { href: href, target: "_blank", rel: "noopener noreferrer" },
        React.createElement(IconActionArrowRight, null),
        " ",
        React.createElement(TruncatedText, null, children)));
};
